/* Publish by EComposer at 2026-10-02 12:23:32*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ehsn4z8scpa"]=  window.__ectimmers["ecom-ehsn4z8scpa"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ehsn4z8scpa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ehsn4z8scpa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xu0t1nawcfo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xu0t1nawcfo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k6uy4ooi11q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k6uy4ooi11q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8acozvie8v7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8acozvie8v7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6d5z1344ifl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6d5z1344ifl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xwniovl2bx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xwniovl2bx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ywqtmnuqlpm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ywqtmnuqlpm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jkbx9jp00p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jkbx9jp00p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4nogawwgkwl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4nogawwgkwl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-av2t39aiodo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-av2t39aiodo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iusaucujlbs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iusaucujlbs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eodnjaruukl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eodnjaruukl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-di8pe1iibz5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-di8pe1iibz5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z0u6wg5i14h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z0u6wg5i14h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dtr39p3j38e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dtr39p3j38e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-85br7jbnj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-85br7jbnj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s5esjxptr19').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s5esjxptr19', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4mszfqgq5lh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4mszfqgq5lh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lbyb8q5l1rl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lbyb8q5l1rl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-drcu1o28t3m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-drcu1o28t3m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5b4vsjcom6m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5b4vsjcom6m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7b8jeu5a5rj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7b8jeu5a5rj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l1zillelzua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l1zillelzua', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-js2e3xhc8xp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-js2e3xhc8xp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qpzy9nmf7ze').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qpzy9nmf7ze', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-d5vfxycfdf"]=  window.__ectimmers["ecom-d5vfxycfdf"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-d5vfxycfdf"]["q2mnpdwua"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-d5vfxycfdf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d5vfxycfdf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xrlij251tlc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xrlij251tlc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w5j3ikxvzec').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w5j3ikxvzec', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dk5aq67uld5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dk5aq67uld5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-da2euqo3ydl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-da2euqo3ydl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kyv0e5g8gqk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kyv0e5g8gqk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3lgmh0r0kq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3lgmh0r0kq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r9s5su8mzbg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r9s5su8mzbg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ctp707dphsa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ctp707dphsa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kcjg9ttcpv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kcjg9ttcpv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ynac7j6nyif').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ynac7j6nyif', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-er5hwx1e66').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-er5hwx1e66', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5qpd8ank1mi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5qpd8ank1mi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bqze2j464mi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bqze2j464mi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-emp0cbhh0as').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-emp0cbhh0as', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pcsh602wjqo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pcsh602wjqo', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qbx7qrglih"]=  window.__ectimmers["ecom-qbx7qrglih"] || {};
if(!this.$el)return;this.isLive,this.$el,document.querySelector('html[dir="rtl"]');class t extends HTMLElement{constructor(){super(),this.containerWidth=0,this.marqueeWidth=0,this.multiplier=1,this.isMounted=!1,this.styleProp={},this.classNameProp="",this.autoFillProp=!1,this.playProp=!0,this.pauseOnHoverProp=!1,this.pauseOnClickProp=!1,this.directionProp="left",this.speedProp=50,this.delayProp=0,this.loopProp=0,this.gradientProp=!1,this.gradientColorProp="white",this.gradientWidthProp=200,this.rootRef=null,this.containerRef=null,this.marqueeRef=null,this.childrenHtml="",this.interval=0,this.duration=0}checkRTL(){if(this.isMounted&&window.getComputedStyle(this).direction==="rtl")return!0;const i=document.documentElement.getAttribute("dir"),o=document.body.getAttribute("dir");return i==="rtl"||o==="rtl"}static get observedAttributes(){return["style","class-name","auto-fill","play","pause-on-hover","pause-on-click","direction","speed","delay","loop","gradient","gradient-color","gradient-width"]}connectedCallback(){this.isMounted=!0,this.childrenHtml=this.innerHTML,this.render();const i=this.querySelectorAll("img");if(i.length>0){let o=!1;const n=()=>{o||(o=!0,this.interval= window.__ectimmers["ecom-qbx7qrglih"]["3jbmv2t15"] = setInterval(()=>this.handle(),500))};setTimeout(n,2e3),Promise.all(Array.from(i).filter(s=>!s.complete).map(s=>new Promise(r=>{s.onload=s.onerror=r}))).then(n)}else setTimeout(()=>{this.handle()},500),this.interval= window.__ectimmers["ecom-qbx7qrglih"]["tmd3qfhk5"] = setInterval(()=>this.handle(),500)}attributeChangedCallback(i,o,n){switch(i){case"style":this.styleProp=n;break;case"class-name":this.classNameProp=n;break;case"auto-fill":this.autoFillProp=n!==null;break;case"play":this.playProp=n!==null;break;case"pause-on-hover":this.pauseOnHoverProp=n=="true";break;case"pause-on-click":this.pauseOnClickProp=n!==null;break;case"direction":const s=this.checkRTL();n=="right"?this.directionProp=s?"right":"left":this.directionProp=s?"left":"right";break;case"speed":this.speedProp=parseInt(n,10)||50;break;case"delay":this.delayProp=parseInt(n,10)||0;break;case"loop":this.loopProp=parseInt(n,10)||0;break;case"gradient":this.gradientProp=n!==null;break;case"gradient-color":this.gradientColorProp=n||"white";break;case"gradient-width":this.gradientWidthProp=parseInt(n,10)||200;break}this.isMounted&&this.render()}render(){const i=this.checkRTL(),o=`
                        --transform: ${this.directionProp==="up"?"rotate(-90deg)":this.directionProp==="down"?"rotate(90deg)":"none"};
                        --width: ${this.directionProp==="up"||this.directionProp==="down"?"100vh":"100%"};
                        --pause-on-hover: ${!this.playProp||this.pauseOnHoverProp?"paused":"running"};
                        display: flex;
                        `,n=`

                        --duration: ${this.duration}s;
                        --play: ${this.playProp?"running":"pause"};
                        --direction: ${this.directionProp==="left"?"normal":"reverse"};
                        --delay: 0s;
                        --iteration-count: infinite;
                        --min-width: ${this.autoFillProp?"auto":"100%"};
                        --percent-start: ${i?"100%":"0%"};
                        --percent-end: ${i?"0%":"-100%"};
                        display: flex;
                    `,s=`
                        <div class="ecom-text-marquee-container ${this.classNameProp}" style="${o}">
                            <div class="ecom-text-marque-wrapper" style="${n}">
                                ${this.renderChildren()}
                            </div>
                            <div class="ecom-text-marque-wrapper" style="${n}">
                                ${this.renderChildren()}
                            </div>
                            <div class="ecom-text-marque-wrapper" style="${n}">
                                ${this.renderChildren()}
                            </div>
                            <div class="ecom-text-marque-wrapper" style="${n}">
                                ${this.renderChildren()}
                            </div>
                            <div class="ecom-text-marque-wrapper" style="${n}">
                                ${this.renderChildren()}
                            </div>
                            <div class="ecom-text-marque-wrapper" style="${n}">
                                ${this.renderChildren()}
                            </div>
                        </div>
                    `;this.innerHTML=s,this.rootRef=this.querySelector(".ecom-text-marquee-container"),this.marqueeRef=this.querySelector(".ecom-text-marque-wrapper")}calculateWidth(){const i=this.rootRef.getBoundingClientRect(),o=this.marqueeRef.getBoundingClientRect();this.containerWidth=i.width>i.height?i.width:i.height,this.marqueeWidth=o.width>o.height?o.width:o.height,this.multiplier=this.autoFillProp&&this.containerWidth&&this.marqueeWidth?Math.ceil(this.containerWidth/this.marqueeWidth)+1:1}calculateDuration(){this.autoFillProp?this.duration=this.marqueeWidth*this.multiplier/this.speedProp:this.duration=this.marqueeWidth<this.containerWidth?this.containerWidth/this.speedProp:this.marqueeWidth/this.speedProp,this.render()}renderChildren(){let i="";for(let o=0;o<this.multiplier;o++)i+=`<div class="ecom-text-marquee-child" style="display: flex">${this.childrenHtml}</div>`;return i}addEventListeners(){this.pauseOnHoverProp&&(this.rootRef.addEventListener("mouseenter",()=>{this.playProp=!1}),this.rootRef.addEventListener("mouseleave",()=>{this.playProp=!0})),this.pauseOnClickProp&&this.rootRef.addEventListener("click",()=>{this.playProp=!this.playProp}),this.marqueeRef.addEventListener("animationiteration",()=>{typeof this.onCycleComplete=="function"&&this.onCycleComplete()}),this.marqueeRef.addEventListener("animationend",()=>{typeof this.onFinish=="function"&&this.onFinish()})}handle(){const i=this;this.duration?clearInterval(i.interval):(i.calculateWidth(),i.calculateDuration(),i.addEventListeners(),i.classList.add("show"))}}customElements.get("ecom-marquee-component")||customElements.define("ecom-marquee-component",t)

                    });
                    
                        document.querySelectorAll('.ecom-qbx7qrglih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qbx7qrglih', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8lc4enh42nk"]=  window.__ectimmers["ecom-8lc4enh42nk"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-8lc4enh42nk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8lc4enh42nk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-93essaxeuli').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93essaxeuli', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bwnnxt3ant').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bwnnxt3ant', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1n4ue2rtcdo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1n4ue2rtcdo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-81jxfgi0qlh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-81jxfgi0qlh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8x5s1abzvac').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8x5s1abzvac', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-upcs0bbvlf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-upcs0bbvlf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qaozfjr9tr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qaozfjr9tr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7acgfejc4i5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7acgfejc4i5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x9bcpqadhrs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x9bcpqadhrs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hfds8gkbti7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hfds8gkbti7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lrjd2wku5zn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lrjd2wku5zn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vehn3hmi6wh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vehn3hmi6wh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7jvg8n1n60i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7jvg8n1n60i', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a539ctakml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a539ctakml', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zl4doi3xukb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zl4doi3xukb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vk2487hsdgm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vk2487hsdgm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fq7gj526imi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fq7gj526imi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r9i4yc3pve').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r9i4yc3pve', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6a8rt0r5y95').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6a8rt0r5y95', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e5f7b5e6ztw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e5f7b5e6ztw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-20b60lhlzjg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-20b60lhlzjg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ivko1vzc23d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ivko1vzc23d', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gfpojhzim9s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gfpojhzim9s', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m7679w9c6rb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m7679w9c6rb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aur0e9aycy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aur0e9aycy', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nildh4fp3ja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nildh4fp3ja', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vdfmdrywl7e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vdfmdrywl7e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a863c68a9ka').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a863c68a9ka', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8xiunbsrfin').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8xiunbsrfin', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s8wm78gbs1l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s8wm78gbs1l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qwy0oeiwbi8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qwy0oeiwbi8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1021rseo6jt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1021rseo6jt', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5g3rt00eob4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5g3rt00eob4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s2v9bflbb48').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s2v9bflbb48', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6v6h87mbfpu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6v6h87mbfpu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i2yspmku6n9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i2yspmku6n9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yvp60k4d3vq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yvp60k4d3vq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e83ecrfw1g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e83ecrfw1g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-htqx5sh5pg6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-htqx5sh5pg6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cr36v7k9tjt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cr36v7k9tjt', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wv7icd1idmp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wv7icd1idmp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-je0g1ndmmpp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-je0g1ndmmpp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nvqchhcgbws').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nvqchhcgbws', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-75271q0ll4x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-75271q0ll4x', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o3g5gif0ek9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o3g5gif0ek9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}